/*
Check to make sure the ID matches what we expect to be a valid
ID format returned from the API

This is used to differentiate between our optimistic UUIDs and confirmed Hatch API IDs
*/

export default (id) => {
  // OLD IDS:

  // valid IDs will always be a string
  // valid IDs will always have a length of 8
  // valid IDs will always be numeric (as a string)

  // NEW MONGO IDS:
  // hex values A-Fa-f0-9
  // length of 24
  return (
    typeof id === 'string' &&
    ((id.length === 8 && !Number.isNaN(Number(id))) ||
      /^[0-9a-fA-F]{24}$/.test(id) ||
      /^[a-z]{1}[0-9]{8}$/.test(id))
  );
};
